export default "__VITE_ASSET__D8Wu9e9T__"